import _extends from "/var/lib/jenkins/jobs/EV/jobs/NextJS/jobs/02-cert-build/workspace/target/checkout/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import React from "react";
var __jsx = React.createElement;
import { SvgIcon } from "@mui/material";
export default function AddIcon(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 86 128",
    height: "10",
    width: "5",
    role: "img",
    "aria-hidden": "true"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 58V20H38v38H0v10h38v38h10V68h38V58z"
  }));
}
AddIcon.defaultProps = {
  fontSize: "small"
};